import {createDivIn, createHeaderIn, createImgIn} from '../../ui_utils/DomUtils'
import {UIGameManager} from '../UIGameManager'
import {PIXI} from '@colonist/pixi'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {ColonistMembershipType, LobbyImage} from '@colonist/types'
import {RandomUtils} from '@colonist/utils'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventType, AnalyticEventCategory, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../analytics/Analytics'
import {ClientUserState} from '../../ClientUserState'
import {TranslationObject} from '@colonist/i18n'
import {navigateToPage} from '../../ui_utils/ClientUtils.ts'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables.ts'
import {uiManagerEvents} from '../../EntryShared.ts'
import {UIUrlParameterNames} from '../../ui_html/UIUrlController.ts'
import {UIEntryUrlParameterController} from '../../UIEntryUrlParameterController.ts'

export interface ItemBoxContent {
    blurb: TranslationObject
    image: LobbyImage
    isRemoveAdContent?: boolean
}
export class UIGameEndItemBoxController {
    itemBoxContainer: HTMLElement
    private readonly itemBoxWidth: number
    private readonly uiGameManager: UIGameManager
    private itemBoxContents: ItemBoxContent[] = [
        {
            blurb: {key: 'strings:game.gameEndItem.defeatBarbarians'},
            image: LobbyImage.StoreItemCitiesAndKnights4P,
        }, {
            blurb: {key: 'strings:game.gameEndItem.useSpecialBuild'},
            image: LobbyImage.StoreItemExpansionClassic78P,
        }, {
            blurb: {key: 'strings:game.gameEndItem.discoverRandomHexes'},
            image: LobbyImage.MapSS3FogIslands4PPreview,
        }, {
            blurb: {key: 'strings:colonistCommon.utils.emptyString'},
            image: LobbyImage.StoreMembershipPerkNoAdsGifDesertHex,
            isRemoveAdContent: true,
        }, {
            blurb: {key: 'strings:colonistCommon.utils.emptyString'},
            image: LobbyImage.StoreMembershipPerkNoAdsGifDesertBox,
            isRemoveAdContent: true,
        }, {
            blurb: {key: 'strings:colonistCommon.utils.emptyString'},
            image: LobbyImage.StoreMembershipPerkNoAdsGifGoldHex,
            isRemoveAdContent: true,
        }, {
            blurb: {key: 'strings:colonistCommon.utils.emptyString'},
            image: LobbyImage.StoreMembershipPerkNoAdsGifGoldBox,
            isRemoveAdContent: true,
        },
    ]

    constructor(uiGameManager: UIGameManager, itemBoxWidth: number) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.itemBoxWidth = itemBoxWidth

        this.createMembershipItemBox()
    }

    static shouldShowEndGameItemBox(showToFounderPackOwners?: boolean): boolean {
        if(ClientUserState.userState == undefined) return true
        const items = ClientUserState.userState.items
        if(items.hasFoundersPack() && showToFounderPackOwners == false) return false
        const membershipType = items.membership
        switch(membershipType) {
            case ColonistMembershipType.EliteMonthly:
            case ColonistMembershipType.EliteYearly:
            case ColonistMembershipType.PremiumMonthly:
            case ColonistMembershipType.PremiumYearly:
                return false
            default:
                return true
        }
    }

    static shouldShowRemoveAdsPerk(): boolean {
        return !ClientUserState.userState?.items.hasMembership()
    }

    setItemBoxVisible(isVisible: boolean) {
        if(isVisible) {
            this.itemBoxContainer.style.display = 'block'
        } else {
            this.itemBoxContainer.style.display = 'none'
        }
    }

    private createMembershipItemBox() {
        this.itemBoxContainer = createDivIn(document.body, 'endgame-item-box')
        const canvas = this.uiGameManager.canvasController
        const canvasX = canvas.responsiveController.getCanvasX()
        const canvasY = canvas.responsiveController.getCanvasY()
        const width = this.itemBoxWidth
        const height = canvas.appH - canvas.itemSize * 5.5

        this.resizeItemBoxSize(width, height)
        this.resizeItemBoxPosition(canvasX, canvasY)

        void this.createContentInItemBox()
    }

    private async createContentInItemBox() {
        if(UIGameEndItemBoxController.shouldShowEndGameItemBox() == false) return
        if(UIGameEndItemBoxController.shouldShowRemoveAdsPerk() == false) {
            this.itemBoxContents = this.itemBoxContents.filter((itemBoxContent) => !itemBoxContent.isRemoveAdContent)
        }
        const randomIndex = RandomUtils.randomIntBetween(0, this.itemBoxContents.length - 1)
        const content: ItemBoxContent = this.itemBoxContents[randomIndex]
        const image = createImgIn(this.itemBoxContainer, content.image)
        if(content.isRemoveAdContent) {
            this.formatContentForRemoveAdsGif(image)
            return
        }
        const aspectRatio = (1200 / 850)
        const itemBoxWidthIsBiggerThanHeight = this.itemBoxContainer.clientWidth / aspectRatio > this.itemBoxContainer.clientHeight
        if(itemBoxWidthIsBiggerThanHeight) {
            image.style.height = '80%'
        } else {
            image.style.width = '80%'
        }
        const header = createHeaderIn(this.itemBoxContainer, content.blurb, '')
        this.itemBoxContainer.onclick = () => {
            UIGameEndItemBoxController.onClickAction()
        }
    }

    private formatContentForRemoveAdsGif(image: HTMLImageElement) {
        this.itemBoxContainer.style.cursor = 'default'
        const aspectRatio = (600 / 425)
        const itemBoxWidthIsBiggerThanHeight = this.itemBoxContainer.clientWidth / aspectRatio > this.itemBoxContainer.clientHeight
        if(itemBoxWidthIsBiggerThanHeight) {
            image.style.height = '100%'
        } else {
            image.style.width = '100%'
        }

        image.style.cursor = 'pointer'
        image.onclick = () => {
            UIGameEndItemBoxController.onClickAction()
        }
    }

    private static onClickAction() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.ItemBoxMembershipEndgame,
        }
        void CA.sendAnalyticEvent(eventData)
        if(UIUtilsEjsVariables.isUserOnDiscord) {
            uiManagerEvents.handleUrlRedirectViaParameters(UIUrlParameterNames.DiscordStore, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE)
            return
        }
        navigateToPage('/store#membership', true)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CanvasResized:
                this.resizeItemBox()
                break
            default: break
        }
    }

    private resizeItemBox() {
        const appW = parseFloat(this.uiGameManager.canvasController.app.view.style.width)
        const appH = parseFloat(this.uiGameManager.canvasController.app.view.style.height)

        const canvas = this.uiGameManager.canvasController
        const widthRatioChanged = appW / canvas.appW
        const heightRatioChanged = appH / canvas.appH
        const x = canvas.responsiveController.getCanvasX()
        const y = canvas.responsiveController.getCanvasY()
        const newWidth = widthRatioChanged * this.itemBoxWidth
        const newHeight = heightRatioChanged * (canvas.appH - canvas.itemSize * 5.5)

        this.resizeItemBoxSize(newWidth, newHeight)
        this.resizeItemBoxPosition(x, y)
    }

    private resizeItemBoxSize(width: number, height: number) {
        let zoom = 1
        if(PIXI.utils.isMobile.phone) zoom = 0.5

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.itemBoxContainer.style.zoom = `${zoom}`

        const MARGIN = this.uiGameManager.canvasController.margin

        const divHeight = (height / zoom) - (MARGIN * 3 / zoom) * 2
        this.itemBoxContainer.style.height = divHeight * .7 + 'px'
        const divWidth = (width / zoom) - (MARGIN * 3 / zoom) * 2
        this.itemBoxContainer.style.width = divWidth + 'px'
    }

    private resizeItemBoxPosition(canvasX: number, canvasY: number) {
        const MARGIN = this.uiGameManager.canvasController.margin
        this.itemBoxContainer.style.left = canvasX + MARGIN + 'px'
        this.itemBoxContainer.style.top = canvasY + MARGIN + 'px'
    }
}
